import React from "react";

type DownloadButtonProps = {
  className?: string;
  children?: React.ReactNode;
  variant?: 'black' | 'white';
};

const APP_STORE_URL = "https://apps.apple.com/us/app/ammopantryai/id6747729414";

const DownloadButton: React.FC<DownloadButtonProps> = ({ className = "", variant = 'black' }) => {
  const isWhite = variant === 'white';
  const bgStyle = isWhite 
    ? { background: '#ffffff !important' }
    : { background: 'linear-gradient(to bottom, #1d1d1f 0%, #000000 100%) !important' };
  const textColor = isWhite ? 'text-black' : 'text-white';
  const borderColor = isWhite ? 'border-black' : 'border-gray-300';
  const logoFill = isWhite ? 'black' : 'white';

  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-3 px-4 rounded-md border ${borderColor} shadow-sm hover:opacity-90 transition-opacity ${isWhite ? '!bg-white' : '!bg-black'} ${className}`}
      style={{
        ...bgStyle,
        minWidth: '155px',
        height: '48px',
        borderWidth: '1px',
      }}
    >
      {/* Apple Logo */}
      <svg
        width="22"
        height="26"
        viewBox="0 0 20 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0"
      >
        <path
          d="M16.5 12.5c-.1-2.4.8-4.3 2.7-5.7-1-1.5-2.5-2.3-4.3-2.4-1.8-.2-3.5 1-4.4 1-1 0-2.3-1-3.8-1-2 0-3.8 1.2-5 3.1-2.2 3.8-.6 9.4 1.5 12.5 1.1 1.5 2.3 3.2 4 3.1 1.6 0 2.2-1 4.1-1 1.9 0 2.4 1 4.1 1 1.7 0 2.8-1.5 3.9-3 1.2-1.8 1.7-3.5 1.7-3.6 0-.1-3.2-1.2-3.3-4.8zm-3.1-8.8c.8-1 1.4-2.4 1.2-3.8-1.2.1-2.6.8-3.5 1.8-.8.9-1.5 2.3-1.3 3.6 1.3.1 2.6-.6 3.6-1.6z"
          fill={logoFill}
        />
      </svg>
      {/* Text */}
      <div className="flex flex-col leading-tight">
        <span className={`text-[10px] ${textColor} leading-[1.1]`} style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif' }}>Download on the</span>
        <span className={`text-[14px] ${textColor} font-semibold leading-[1.1]`} style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', letterSpacing: '-0.01em' }}>App Store</span>
      </div>
    </a>
  );
};

export default DownloadButton;

